__webpack_require__.p = "https://ca.knowledgesearchcore.thomsonreuters.com/";